module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r1r4n8r-f3f3a04ab121409e6674f40e94163d11.svg";